import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { FilterValue } from '@pflegia/types/api/job-board/filter-value';

const LOCAL_STORAGE_KEY = 'candidate-job-board-filters';

export interface FiltersStateType {
  filters: FilterValue[];
  filtersFullyInitialized: boolean;
  setFilters: (filters: FilterValue[]) => void;
  setFiltersFullyInitialized: (state: boolean) => void;
}

let setStoreState: (state: Partial<FiltersStateType>) => void;

export const useFiltersLocalStorage = create<FiltersStateType>()(
  persist(
    set => {
      setStoreState = set;
      return {
        filters: [],
        filtersFullyInitialized: false,
        setFilters: filters => set({ filters }),
        setFiltersFullyInitialized: (state: boolean) => set({ filtersFullyInitialized: state }),
      };
    },
    {
      name: LOCAL_STORAGE_KEY,
      storage: createJSONStorage(() => window.localStorage),
      onRehydrateStorage: () => () => {
        setStoreState({
          // Reset filtersFullyInitialized (in-memory) to false to avoid unnecessary requests on page re-loads
          filtersFullyInitialized: false,
        });
      },
    },
  ),
);
